import Add from "@mui/icons-material/Add";
import Delete from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React from "react";
import { useFieldArray } from "react-hook-form";
import ConfigValidationRuleTypeDialog from "../../useDialogs/ConfigValidationRuleTypeDialog";
import { useDialogs } from "../../useDialogs/useDialogs";
import {
  defaultJsonataValidationRule,
  defaultLLMValidationRule,
} from "./ConfigDefault";
import {
  useConfigModeContext,
  useFormConfigContext,
} from "./ConfigFormContext";
import ConfigValidationRule from "./ConfigValidationRule";

const ConfigValidation: React.FC = () => {
  const { control, setValue } = useFormConfigContext();
  const { isReadOnly } = useConfigModeContext();
  const dialogs = useDialogs();

  const {
    fields: documentRules,
    append: addDocumentRule,
    remove: removeDocumentRule,
  } = useFieldArray({
    control,
    name: "config.validation.document_rules",
  });
  const {
    fields: assetRules,
    append: addAssetRule,
    remove: removeAssetRule,
  } = useFieldArray({
    control,
    name: "config.validation.asset_rules",
  });

  return (
    <>
      <div className="flex justify-between items-center">
        <Typography className="text-xl font-semibold">Validation</Typography>
        {!isReadOnly && (
          <Button
            color="error"
            onClick={() => setValue("config.validation", undefined)}
          >
            <Delete />
          </Button>
        )}
      </div>
      <Stack rowGap={2} className="py-4 px-4 overflow-y-scroll">
        {assetRules && (
          <div className="flex justify-between items-center">
            <Typography className="text-lg font-semibold">
              Validations dossier
            </Typography>
            {!isReadOnly && (
              <Button
                size="small"
                variant="contained"
                className="gap-2"
                onClick={() =>
                  dialogs.open(ConfigValidationRuleTypeDialog, {
                    addLLMQuery: () => addAssetRule(defaultLLMValidationRule()),
                    addJsonataQuery: () =>
                      addAssetRule(defaultJsonataValidationRule()),
                  })
                }
              >
                <Add />
                Validation dossier
              </Button>
            )}
          </div>
        )}
        {assetRules?.map((rule, index) => {
          return (
            <ConfigValidationRule
              key={rule.id}
              index={index}
              removeRule={() => removeAssetRule(index)}
              path="asset_rules"
            />
          );
        })}
        {!assetRules?.length && (
          <div className="flex justify-between items-center">
            <Typography className="italic">
              Aucune validation dossier
            </Typography>
          </div>
        )}
        {documentRules && (
          <div className="flex justify-between items-center">
            <Typography className="text-lg font-semibold">
              Validations document
            </Typography>
            {!isReadOnly && (
              <Button
                size="small"
                variant="contained"
                className="gap-2"
                onClick={() => addDocumentRule(defaultJsonataValidationRule())}
              >
                <Add />
                Validation document
              </Button>
            )}
          </div>
        )}
        {documentRules?.map((rule, index) => {
          return (
            <ConfigValidationRule
              key={rule.id}
              index={index}
              removeRule={() => removeDocumentRule(index)}
              path="document_rules"
            />
          );
        })}
        {!documentRules?.length && (
          <div className="flex justify-between items-center">
            <Typography className="italic">
              Aucune validation document
            </Typography>
          </div>
        )}
      </Stack>
    </>
  );
};
export default ConfigValidation;
